/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { CustomerVaultAccount } from '../models/CustomerVaultAccount';

export class ReconnectCustomerVaultAccountResponse {
  'customerVaultAccount': CustomerVaultAccount;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "customerVaultAccount",
      "baseName": "customerVaultAccount",
      "type": "CustomerVaultAccount",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return ReconnectCustomerVaultAccountResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

